import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { ref, computed, onMounted } from "vue";

import {
  useSegmentsStore,
  SegmentsParams,
  FilterForm,
} from "@/store/segments/segments";
import { useAuthStore } from "@/store/auth/login";
import { storeToRefs } from "pinia";
import { useSegmentsDictionariesStore } from "@/store/dictionaries/segments";
import { setParamsByFilter } from "@/services/segments/utils";
import { rowsCount } from "@/services/utils/Pagination";

import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import TopSegmentsPanel from "@/entities/segments/panels/TopListSegmentsPanel.vue";
import SegmentsTable from "@/entities/segments/SegmentsTable.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import SegmentFilterForm from "@/entities/segments/forms/SegmentsFilterForm.vue";
import Paginator from "primevue/paginator";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListSegmentsPage',
  setup(__props) {

const segmentsStore = useSegmentsStore();
const authStore = useAuthStore();
const segmentsDictionariesStore = useSegmentsDictionariesStore();
const isArchiveEnabled = ref(false);
const isFilterEnabled = ref(false);
const isLoading = ref(false);
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  stateId: 0,
  stateIdIn: "",
  filter: {} as FilterForm,
  commonFilter: "",
});
const isFilterSetted = ref(false);

const filteredSegments = computed(() => {
  return segmentsStore.segmentsList;
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions([
    "segment:read",
    "segment:edit",
    "system:read",
    "system:edit",
  ]);
});

onMounted(() => {
  if (isDenied.value) return;
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  segmentsDictionariesStore.getStates().then(() => {
    tableDisplaySettings.value.stateIdIn =
      segmentsDictionariesStore.defaultStates;
    updateSegmentsList();
  });
  segmentsDictionariesStore.getTypes();
};

const activeFirstFromStore = computed(() => segmentsStore.activeFirst);

const updatePaginator = () => {
  updateSegmentsList();
};

const updateSegmentsList = () => {
  let isEnded = false;

  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);

  const params: SegmentsParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(43),
  };

  setParamsByFilter(params, tableDisplaySettings.value);

  if (params.state_id__in != "")
    segmentsStore.getSegments(params).finally(() => {
      isLoading.value = false;
      isEnded = true;
    });
  else {
    isLoading.value = false;
    isEnded = true;
  }
};

const toggleArchive = () => {
  isArchiveEnabled.value = !isArchiveEnabled.value;
  tableDisplaySettings.value.first = 0;
  if (isArchiveEnabled.value)
    tableDisplaySettings.value.stateId =
      segmentsDictionariesStore.statesMap.get("archived")?.id || 0;
  else tableDisplaySettings.value.stateId = 0;
  updateSegmentsList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updateSegmentsList();
};

const setFilter = (filter: object, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updateSegmentsList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  if (segmentsDictionariesStore.defaultStates.length > 0) updateSegmentsList();
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateSegmentsList, 200);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(SegmentFilterForm, {
            isFilterEnabled: isFilterEnabled.value,
            onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value)),
            onSetFilter: setFilter
          }, null, 8, ["isFilterEnabled"]),
          _createVNode(TopSegmentsPanel, {
            isArchiveEnabled: isArchiveEnabled.value,
            isFilterEnabled: isFilterEnabled.value,
            isFilterSetted: isFilterSetted.value,
            onToggleArchive: toggleArchive,
            onSetCommonFilter: setCommonFilter,
            onToggleFilter: _cache[1] || (_cache[1] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value))
          }, null, 8, ["isArchiveEnabled", "isFilterEnabled", "isFilterSetted"]),
          _createElementVNode("div", {
            id: "table-container",
            class: _normalizeClass(["table-container flex flex-col", [filteredSegments.value.length == 0 ? 'empty' : 'filled']])
          }, [
            _createVNode(SegmentsTable, {
              segments: filteredSegments.value,
              isArchiveEnabled: isArchiveEnabled.value,
              isActiveFirst: activeFirstFromStore.value,
              isLoading: isLoading.value,
              rowsCount: _unref(rowsCount)(43) * tableDisplaySettings.value.first,
              onSortTable: sortTable,
              onUpdateTable: updateSegmentsList
            }, null, 8, ["segments", "isArchiveEnabled", "isActiveFirst", "isLoading", "rowsCount"]),
            (filteredSegments.value.length == 0 && !isLoading.value)
              ? (_openBlock(), _createBlock(EmptyTableMessage, { key: 0 }))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_unref(Paginator), {
            first: tableDisplaySettings.value.first,
            "onUpdate:first": [
              _cache[2] || (_cache[2] = ($event: any) => ((tableDisplaySettings.value.first) = $event)),
              updatePaginator
            ],
            rows: 1,
            class: "s-paginator",
            totalRecords: _unref(segmentsStore).segmentsPagesCount,
            template: "PrevPageLink CurrentPageReport NextPageLink",
            currentPageReportTemplate: "{first} из {totalRecords}"
          }, null, 8, ["first", "totalRecords"])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})